































import { Component, Prop, Vue, Inject } from 'vue-property-decorator';
import { List } from 'linqts'
import moment from "moment";

// Servicios
import { logService } from '@/services/LogService';
import { eventService } from "@/services/EventService";
import { toastService } from '@/services/ToastService';
import GenericService from '@/services/GenericService';
import GenericStore from '@/services/GenericStore';

import { Sorteo } from '@/model/Sorteo';
import SorteoEstadisticaComparativaHistorico from './SorteoEstadisticaComparativaHistorico.vue';
import SorteoEstadisticaGlobales from './SorteoEstadisticaGlobales.vue';
import SorteoEstadisticaTotal from './SorteoEstadisticaTotal.vue';

@Component({
  components: {
    SorteoEstadisticaComparativaHistorico,
    SorteoEstadisticaGlobales,
    SorteoEstadisticaTotal
  },
})
export default class SorteoHistoricoTotales extends Vue {

  @Prop({ type: Number, default: 0 })
  idSorteo!: number;

  visibleComparativaHistorico: boolean = false;
  visibleEstadisticas: boolean = false;
  visibleTotales: boolean = false;

  mounted() {

  }

  created(){
    this.visibleComparativaHistorico = true;
    this.load();
  }

  load(){
    
  }

  setVisibleComparativaHistorico(){
    logService.Info("Inicio - Sorteo: "+this.idSorteo,"SorteoHistoricoTotales.vue - setVisibleComparativaHistorico()");
    this.visibleComparativaHistorico = true;
    this.visibleEstadisticas = false;
    this.visibleTotales = false;
  }

  setVisibleEstadisticas(){
    logService.Info("Inicio - Sorteo: "+this.idSorteo,"SorteoHistoricoTotales.vue - setVisibleEstadisticas()");
    this.visibleComparativaHistorico = false;
    this.visibleEstadisticas = true;
    this.visibleTotales = false;
  }

  setVisibleTotales(){
    logService.Info("Inicio - Sorteo: "+this.idSorteo,"SorteoHistoricoTotales.vue - setVisibleTotales()");
    this.visibleComparativaHistorico = false;
    this.visibleEstadisticas = false;
    this.visibleTotales = true;
  }

}
